import React, { Component } from 'react'
import { Route, Switch } from 'react-router-dom'

import { AuthRequiredRoute } from 'utils/router'

import Dashboard from 'containers/Dashboard'
import NotFound from 'scenes/NotFound'
import ConsentGenerator from 'scenes/ConsentGenerator'

// import routes from modules
import accounts from './accounts'
import clients from './clients'
import claims from './claims'

/*
* Routes Object. Accepts nested routes.
*/
const routes = {
  claims,
  accounts,
  clients,
  consent_generator: {
    path: '/reporte_semanal_brokers',
    component: ConsentGenerator,
    container: Dashboard
  },
  not_found: {
    path: '/',
    component: NotFound,
    exact: false,
    container: Dashboard
  },
}

/*
* Converts Object of Routes to List representation
* { routeName: {...props}} => [{key:routeName, ...props}]
*/
const convertToList = (routes) => {
  if(typeof routes !== 'object'){
    return []
  }

  return Object.keys(routes).map((routeKey) => {
    return {key: routeKey, ...routes[routeKey]}
  })
}

/*
* Walks through `route.routes` to assemble final path
* Arguments:
*   name: subroutes concatenated by `:` i.e => 'root:index:nasty'
*/
export const reverse = (name, params = {}) => {
  const chunks = name.split(':')
  let chunkIdx = 0,
    chunk = chunks[chunkIdx],
    route = routes[chunk],
    uri = route.path

  for(++chunkIdx; chunkIdx<chunks.length; chunkIdx++){
    chunk = chunks[chunkIdx]
    route = route.routes[chunk]
    if(typeof route === 'undefined'){
      throw new Error(`Invalid sub-route: ${chunk}`)
    }

    // replace `route.path` params with value in argument `params`
    uri += route.path
  }

  return uri.replace(/:([a-zA-Z_]+)/g, (match, key) => params[key] || key)
}


const DefaultContainer = (props) => (
  <div>
    {props.children}
  </div>
)


class Routes extends Component {
  constructor(props) {
    super(props)

    this.routes = convertToList(routes)
    this._renderRoute = this._renderRoute.bind(this)
  }

  /*
  * Render Route components and SubRoutes
  * **handles nested Routes with recursive calls.**
  */
  _renderRoute(route, idx, array, parentPath = '', prevBreadcrumb = [], parentContainer) {
    const { component, container, exact = true, requiresAuth = true, breadcrumb = '', ...routeProps } = route
    let subRoutes = convertToList(route.routes)
    const path = parentPath + route.path
    const nextPath = parentPath + route.path
    const routeContainer = container || parentContainer
    const Container = routeContainer || DefaultContainer

    let nextBreadcrumb = prevBreadcrumb.slice()
    // if current route has a defined breadcrumb value, add it
    if ( !!breadcrumb )
      nextBreadcrumb.push({name: breadcrumb, path})
    else  // if not, ignore breadcrumb
      nextBreadcrumb = []

    const _render = (Container, component, breadcrumb = []) => {
      return (props) => {
        const componentProps = {...props, breadcrumb}
        let Component = component ? React.createElement(component, componentProps) : null
        return (
          <Container>
            {Component}
          </Container>
        )
      }
    }

    if (exact) {
      routeProps.exact = true
    }

    // avoid rendering route without component
    const RouteComponent = requiresAuth ? AuthRequiredRoute : Route
    const RootRoute = route.component ? <RouteComponent {...routeProps} path={path} key={path} render={ _render(Container, component, nextBreadcrumb) }/> : null
    return subRoutes.length > 0 ? (
      [
        RootRoute,
        ...subRoutes.map((subRoute, index, array) => this._renderRoute(subRoute, index, array, nextPath, nextBreadcrumb, subRoute.container || Container))
      ]
    ) : <RouteComponent {...routeProps} path={path} key={path} render={ _render(Container, component, nextBreadcrumb) } />
  }

  render() {
    return(
      <Switch>
        {this.routes.map(this._renderRoute)}
      </Switch>
    )
  }
}

export default function createRoutes() {
  return <Routes />
}



// WEBPACK FOOTER //
// ./src/routes/index.js